module.exports = __webpack_public_path__ + "static/media/floral-bud-design-with-curls-svgrepo-com.2956669f.svg";